import './styles.scss';

import { Modal as BootstrapModal } from 'react-bootstrap';
import Button from '@/common/Button';
import ModalBody from '@/common/Modal/ModalBody';
import ModalFooter from '@/common/Modal/ModalFooter';
import ModalHeader from '@/common/Modal/ModalHeader';
import { ModalTypes } from '@/common/Modal/types';
import { getClasses } from '@/utils';

const Modal = ({
  title,
  icon,
  content: Content,
  header: Header,
  footer: Footer,
  children,
  showClose = true,
  ...bootstrapModalProps
}: ModalTypes.Props): JSX.Element => {
  return (
    <BootstrapModal
      {...bootstrapModalProps}
      className={getClasses('Modal', bootstrapModalProps.className)}
      backdropClassName={getClasses('Modal-Backdrop', bootstrapModalProps.backdropClassName)}
      dialogClassName={getClasses('Modal-Dialog', bootstrapModalProps.dialogClassName)}
      contentClassName={getClasses('Modal-Content', bootstrapModalProps.contentClassName)}
    >
      {showClose !== false && bootstrapModalProps.onHide && (
        <Button className="CloseButton Modal-Close" variant="icon" onClick={bootstrapModalProps.onHide}>
          <i className="sv sv-cross" />
        </Button>
      )}
      {Content && <Content />}
      <ModalHeader title={title} icon={icon}>
        {Header && <Header />}
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>{Footer && <Footer />}</ModalFooter>
    </BootstrapModal>
  );
};

export default Modal;
